import { render, staticRenderFns } from "./RolesEditor.vue?vue&type=template&id=68357682&scoped=true"
import script from "./RolesEditor.vue?vue&type=script&lang=js"
export * from "./RolesEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68357682",
  null
  
)

export default component.exports